<template>
  <div>
    <div class="bg-vlight-paper shadow rounded-lg p-5">
      <div class="flex justify-center items-center mt-5 mb-10">
        <select
          v-model="selected"
          class="h-10 w-full sm:w-2/4 border border-darkpurple rounded-md shadow-small"
        >
          <option disabled value="">Please select a chat</option>
          <option v-for="option in options"
                  :value="option"
                  :key="option._id"
                  :class="{'bg-gray-200 font-bold': option.watchStatus === 'LIVE'}"
          class="h-10 p-5 m-5">
            {{ option.title }}
          </option>
        </select>
      </div>

      <h3
        v-if="showChat"
        class="flex justify-center text-2xl leading-8 font-bebas  tracking-wide text-darkpurple font-extrabold  sm:text-3xl sm:leading-9 mb-2"
      >
        {{ selected.title }} -
        <span class="relative inline-flex h-4 w-4 ml-2">
          <span
            class="relative inline-flex items-center rounded-full h-4 w-4"
            :class="{ 'bg-red-500': isLive, 'bg-green': !isLive }"
          >
          </span>
        </span>
        <span v-if="isLive" class="ml-2 text-red-500">Live</span>
        <span v-else class="ml-2 text-green">OFFLINE</span>
      </h3>

      <div v-if="showChat" class="flex justify-center">
        <div class="w-full sm:w-2/4">
          <chat-box :session="selected" :admin-chat="true"></chat-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

  import { sanityClient } from "../utils/sanity";
  import ChatBox from "../components/ChatBox";

  export default {
  name: "AdminChat",
  components: {ChatBox},
  data() {
    return {
      selected: '',
      options: [],
      id: null
    };
  },
  created() {
    this.fetchSessions();
  },
    computed: {
    showChat() {
      return typeof this.selected === "object";
    },
      isLive() {
      return this.selected.watchStatus === 'LIVE'
      }
    },
  methods: {
    preselectOption() {
      if (this.$route.params.id !== 'undefined' && this.$route.params.id != null) {
        this.selected = this.options.filter(el => el._id === this.$route.params.id)[0]
      }
    },
      fetchSessions(){
        const queryString = `
    {
        "sessions" :  *[_type == 'session']{
         speakers[]->{...},
            productCompatibility[]->{...},
             ...
             },
    }
    `;

        sanityClient
        .fetch(queryString)
        .then(res => {
          console.log(res);
          console.log(res);
          this.options = res.sessions;
          this.preselectOption();
        })
        .catch(error => console.log(error))

      }
  }
};
</script>
<style>

</style>
